import { bool, elementType, node, string, shape } from "prop-types";
import deprecated from "prop-types-extra/lib/deprecated";
export var linkTypes = {
  children: node.isRequired,
  className: string,
  lineHeight: string,
  component: elementType,
  minor: bool,
  isButton: bool,
  /* TODO : Deprecated props, removed when migration done */
  arrow: deprecated(bool, "This behavior has been removed"),
  color: deprecated(string, "This option has been removed - always a black link"),
  dataSpacer: deprecated(string, "Use `data-spacer` instead."),
  icon: deprecated(shape({
    id: string
  }), "This behavior has been removed"),
  noCcTheme: deprecated(bool, "This behavior has been removed - no more color options, so no more ccTheme options"),
  reset: deprecated(bool, "This option has been removed"),
  variant: deprecated(string, "This option has been removed - there is only one type of Link")
};